/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--paginated_loadmore')) {
        this.paginatedLoadmore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    addUrlParamforPaginatedLoadmore(search, key) {
      let newPage = this.i;
      let newParam = key + '=' + newPage;
      let params = '?' + newParam;

      let newUrl = document.location.pathname + params;
      window.history.replaceState(null, null, newUrl);

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function() {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    paginatedLoadmore() {
      let base = this;
      this.button.addEventListener('click', function() {
        base.i = base.getCurrentPageNumber() + 1;
        base.loadProductsforPaginatedLoadmore();
        base.updatePaginationNavigation();
        this.blur();
        return false;
      });
    }
    getCurrentPageNumber() {
      const urlParams = new URLSearchParams(window.location.search);
      return parseInt(urlParams.get('page')) || 1;
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    loadProductsforPaginatedLoadmore() {
      let base = this,
          url = document.location.pathname + base.addUrlParamforPaginatedLoadmore(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      fetch(url)
          .then(response => response.text())
          .then((responseText) => {
            const html = responseText;

            // Перевіряємо, чи є нові продукти для завантаження
            let grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

            let currentPage = base.getCurrentPageNumber();
            let maxPages = parseInt(base.button.dataset.pages);
            console.log('currentPage', currentPage)
            console.log('maxPages', maxPages)
            if (currentPage >= maxPages) {
              base.button.classList.add('visually-hidden');
            }

            if (!grid_to_replace || grid_to_replace.querySelectorAll('.column').length === 0) {
                base.button.classList.add('visually-hidden');
              return;
            }
            // Якщо є нові продукти, рендеримо їх
            base.renderProducts(html, url);
            dispatchCustomEvent('pagination:page-changed', {
              url: url
            });
          })
          .catch((error) => {
            console.error('Error loading products:', error);
          })
          .finally(() => {
            base.removeAttribute('loading');
          });
    }

    async updatePaginationNavigation() {
      try {
        // Отримуємо нову пагінацію з асинхронного запиту
        const response = await fetch(document.location.href);
        const html = await response.text();

        // Отримуємо елемент пагінації з нової сторінки
        const newPagination = new DOMParser().parseFromString(html, 'text/html').querySelector('.page-numbers.nav-links');

        // Замінюємо поточну пагінацію на нову
        const currentPagination = document.querySelector('.page-numbers.nav-links');
        currentPagination.replaceWith(newPagination);

        // Оновлюємо обробники подій для нових елементів пагінації
        this.addPaginationEventListeners();

      } catch (error) {
        console.error('Error updating pagination navigation:', error);
      }
    }

    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function() {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}